// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c981c377","453":"bb53e782"}[chunkId] + ".chunk.js";
};